import { useState, useEffect } from 'react'
import { BRAZILIAN_STATES } from '../../constants/tax-constants'
import { getNCMValidationRules } from '../../utils/ncm-helpers'

// Função para aplicar máscara de porcentagem similar ao preço
const applyPercentageMaskLikePrice = (value) => {
  if (!value) return ''
  
  let cleanValue = value.replace(/\D/g, '')
  
  if (!cleanValue) return ''
  
  const valueInCents = parseInt(cleanValue, 10)
  const valueInPercentage = valueInCents / 100
  
  return valueInPercentage.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}

export const AliquotasTable = ({
  register,
  errors,
  watch,
  setValue,
  isCreatingNCM = false,
  title,
  description
}) => {
  // Estados disponíveis para a tabela (excluindo o primeiro que é vazio)
  const availableStates = BRAZILIAN_STATES.filter(state => state.value !== '')

  // Aplicar máscara de porcentagem nos campos FCP e ICMS interno
  useEffect(() => {
    availableStates.forEach(state => {
      const fcpFieldName = `fcp_${state.value.toLowerCase()}`
      const icmsFieldName = `icms_interno_${state.value.toLowerCase()}`
      
      // Aplicar máscara no campo FCP
      const fcpCurrentValue = watch ? watch(fcpFieldName) : null
      if (fcpCurrentValue !== undefined && fcpCurrentValue !== null && fcpCurrentValue !== '') {
        const maskedValue = applyPercentageMaskLikePrice(fcpCurrentValue.toString())
        if (maskedValue !== fcpCurrentValue && setValue) {
          setValue(fcpFieldName, maskedValue, { shouldValidate: false })
        }
      }
      
      // Aplicar máscara no campo ICMS interno
      const icmsCurrentValue = watch ? watch(icmsFieldName) : null
      if (icmsCurrentValue !== undefined && icmsCurrentValue !== null && icmsCurrentValue !== '') {
        const maskedValue = applyPercentageMaskLikePrice(icmsCurrentValue.toString())
        if (maskedValue !== icmsCurrentValue && setValue) {
          setValue(icmsFieldName, maskedValue, { shouldValidate: false })
        }
      }
    })
  }, [availableStates, watch, setValue])

  return (
    <div>
      <div className="flex items-center gap-2 mb-3">
        <h5 className="text-sm font-medium text-gray-700 mb-0">
          {title}
        </h5>
        <span className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded">
          Opcional
        </span>
      </div>  
      
      <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-md">
        <p className="text-xs text-blue-700 mb-0">
          {description}
        </p>
      </div>
      
      <div className="overflow-x-auto">
        <table className="w-full text-sm border border-gray-300 rounded-md">
          <thead>
            <tr className="bg-gray-50">
              <th className="border border-gray-300 px-3 py-2 text-left font-medium">Estado</th>
              <th className="border border-gray-300 px-3 py-2 text-center font-medium">FCP (%)</th>
              <th className="border border-gray-300 px-3 py-2 text-center font-medium">ICMS Interno (%)</th>
            </tr>
          </thead>
          <tbody>
            {availableStates.map(state => {
              const fcpFieldName = `fcp_${state.value.toLowerCase()}`
              const icmsFieldName = `icms_interno_${state.value.toLowerCase()}`
              
              return (
                <tr key={state.value}>
                  <td className="border border-gray-300 px-3 py-2 font-medium bg-gray-50">
                    {state.label}
                  </td>
                  <td className="border border-gray-300 px-2 py-2">
                    <div className="flex items-center justify-center">
                      <div className="relative w-20">
                        <input
                          {...register(fcpFieldName, getNCMValidationRules(fcpFieldName, isCreatingNCM))}
                          type="text"
                          placeholder="Padrão"
                          className="w-full text-sm px-2 py-1 pr-6 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        />
                        <span className="absolute right-2 top-1/2 transform -translate-y-1/2 text-xs text-gray-500">%</span>
                      </div>
                    </div>
                    {errors[fcpFieldName] && (
                      <p className="mt-1 text-xs text-red-600 text-center">{errors[fcpFieldName].message}</p>
                    )}
                  </td>
                  <td className="border border-gray-300 px-2 py-2">
                    <div className="flex items-center justify-center">
                      <div className="relative w-20">
                        <input
                          {...register(icmsFieldName, getNCMValidationRules(icmsFieldName, isCreatingNCM))}
                          type="text"
                          placeholder="Padrão"
                          className="w-full text-sm px-2 py-1 pr-6 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        />
                        <span className="absolute right-2 top-1/2 transform -translate-y-1/2 text-xs text-gray-500">%</span>
                      </div>
                    </div>
                    {errors[icmsFieldName] && (
                      <p className="mt-1 text-xs text-red-600 text-center">{errors[icmsFieldName].message}</p>
                    )}
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
} 